import { LegalLayout } from '../components/LegalLayout';

export function AupPage() {
  return (
    <LegalLayout title="Acceptable Use Policy" lastUpdated="June 11, 2026">
      <p>
        This Acceptable Use Policy (the <strong>"AUP"</strong>) governs your use of
        PROTBYTE Sentinel (the <strong>"Service"</strong>), operated by{' '}
        <strong>PROTBYTE</strong>. It supplements, and is incorporated into,
        our <a href="/terms">Terms of Service</a>. Capitalized terms have the
        meanings given in the Terms. By using the Service, you agree to this AUP. If
        you do not agree, do not use the Service.
      </p>

      <h2>1. Authorization is required</h2>
      <p>
        The Service actively queries and probes the domain you submit, including
        sending requests to its hosts and well-known paths.{' '}
        <strong>
          You may only submit a domain that you own or that you have explicit,
          current authorization from the owner to assess.
        </strong>{' '}
        You are solely responsible for confirming that authorization before each
        scan. Scanning a domain without authorization may be unlawful and may
        violate computer-misuse and unauthorized-access laws in your jurisdiction
        and the target's. You assume all risk and liability for the domains you
        choose to submit.
      </p>

      <h2>2. Prohibited uses</h2>
      <p>You agree that you will not, and will not attempt to, use the Service to:</p>
      <ul>
        <li>
          scan, probe, or assess any domain you do not own or do not have explicit
          permission to assess;
        </li>
        <li>
          attack, compromise, disrupt, degrade, overload, or gain unauthorized
          access to any system, network, or data, or to plan, support, or
          facilitate any of the foregoing;
        </li>
        <li>
          conduct reconnaissance, enumeration, or vulnerability research against
          targets you are not authorized to test;
        </li>
        <li>
          circumvent, disable, or interfere with the rate limit, the
          human-verification challenge (Cloudflare Turnstile), authentication, or
          any other security or technical control of the Service;
        </li>
        <li>
          access the Service through automated, scripted, headless, crawling,
          scraping, bulk, or high-volume means, or build a competing or derivative
          service from such access;
        </li>
        <li>
          resell, sublicense, rent, or commercially redistribute the Service or its
          output without our prior written consent;
        </li>
        <li>
          use the Service in connection with any unlawful, fraudulent, harassing,
          defamatory, infringing, or otherwise abusive activity, or in any manner
          that violates the rights of others;
        </li>
        <li>
          impose an unreasonable or disproportionately large load on the Service or
          on any third-party data source it relies on;
        </li>
        <li>
          misrepresent your identity or authorization, or forge headers or other
          data to evade controls;
        </li>
        <li>
          use the Service in violation of any applicable law, regulation, sanctions
          regime, or export control.
        </li>
      </ul>

      <h2>3. Fair-use and technical limits</h2>
      <p>
        The Service is a free, browser-based tool intended for interactive use. It
        applies a per-IP rate limit and a human-verification challenge. You must not
        attempt to exceed, evade, or automate around these limits. We may adjust
        limits, add controls, or take protective measures at any time without
        notice.
      </p>

      <h2>4. Enforcement</h2>
      <p>
        We may investigate suspected violations and may, at our sole discretion and
        without notice, rate-limit, throttle, suspend, block, or terminate access
        for any client or person we reasonably believe is violating this AUP, the
        Terms, or applicable law. We may also preserve and disclose information where
        required by law or where we believe in good faith it is necessary to protect
        the rights, property, or safety of PROTBYTE, our users, or the public,
        and we may cooperate with law-enforcement authorities. Enforcement, or the
        lack of it, does not waive our right to act on any other violation.
      </p>

      <h2>5. Reporting abuse</h2>
      <p>
        If you believe the Service is being misused, or that a scan was performed
        against a domain without authorization, please report it to{' '}
        <a href="mailto:contact@protbyte.com">contact@protbyte.com</a>.
      </p>

      <h2>6. Changes to this AUP</h2>
      <p>
        We may update this AUP from time to time. The updated version takes effect
        when posted at this URL, and the "Last updated" date will change. Your
        continued use of the Service after a change constitutes acceptance of the
        revised AUP.
      </p>

      <h2>7. Contact</h2>
      <p>
        Questions about this AUP? Email us at{' '}
        <a href="mailto:contact@protbyte.com">contact@protbyte.com</a>.
      </p>
    </LegalLayout>
  );
}
